import React, { useState, useEffect } from 'react';
import '../styles/Social.css';

const API = process.env.REACT_APP_SERVER_URL || '';
const headers = () => ({
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json'
});

const InspectModal = ({ targetId, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!targetId) return;
    (async () => {
      try {
        const res = await fetch(`${API}/api/social/inspect/${targetId}`, { headers: headers() });
        const json = await res.json();
        if (!res.ok) { setError(json.error || 'Failed to inspect'); return; }
        setData(json.profile);
      } catch (e) { setError('Network error'); }
      finally { setLoading(false); }
    })();
  }, [targetId]);

  const getRarityClass = (rarity) => {
    switch (rarity) {
      case 'legendary': return 'rarity-legendary';
      case 'epic': return 'rarity-epic';
      case 'rare': return 'rarity-rare';
      case 'uncommon': return 'rarity-uncommon';
      default: return 'rarity-common';
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content inspect-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🔍 Inspect Player</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {loading && <div className="modal-loading">Loading...</div>}
        {error && <div className="inspect-error">{error}</div>}

        {data && (
          <div className="inspect-body">
            <div className="inspect-header-info">
              <h3 className="inspect-name">
                {data.guild?.tag && <span className="inspect-guild-tag">[{data.guild.tag}]</span>}
                {data.name}
              </h3>
              <div className="inspect-subtitle">
                Level {data.level} {data.advancedClass || data.class} ({data.race})
              </div>
              {data.guild?.name && (
                <div className="inspect-guild">Guild: {data.guild.name}</div>
              )}
            </div>

            <div className="inspect-stats">
              <h4>Stats</h4>
              <div className="inspect-stat-grid">
                <div className="inspect-stat"><span className="stat-label">STR</span> {data.stats?.STR}</div>
                <div className="inspect-stat"><span className="stat-label">AGL</span> {data.stats?.AGL}</div>
                <div className="inspect-stat"><span className="stat-label">VIT</span> {data.stats?.VIT}</div>
                <div className="inspect-stat"><span className="stat-label">MEN</span> {data.stats?.MEN}</div>
                <div className="inspect-stat"><span className="stat-label">CHA</span> {data.stats?.CHA}</div>
              </div>
            </div>

            {data.equipment && Object.keys(data.equipment).length > 0 && (
              <div className="inspect-equipment">
                <h4>Equipment</h4>
                {Object.entries(data.equipment).map(([slot, item], i) => (
                  <div key={i} className={`inspect-equip-row ${getRarityClass(item.rarity)}`}>
                    <span className="inspect-equip-slot">{slot}</span>
                    <span className="inspect-equip-name">{item.name}</span>
                  </div>
                ))}
              </div>
            )}

            {data.arena && (
              <div className="inspect-arena">
                <h4>Arena Record</h4>
                <span className="arena-wins">{data.arena.wins}W</span>
                <span className="arena-losses">{data.arena.losses}L</span>
                <span className="arena-draws">{data.arena.draws}D</span>
              </div>
            )}

            {data.pet && (
              <div className="inspect-pet">
                <h4>Companion</h4>
                <span>{data.pet.name} (Lv.{data.pet.level})</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default InspectModal;
